/** IDs das consultas no catálogo GET /reports/diretoria/query-catalog */

export const DIRETORIA_EXECUTIVE_QUERY_IDS: Record<string, string> = {
  'exec-faturamento-mes': 'erp-faturamento-mes',
  'exec-receita-projetada': 'erp-receita-projetada',
  'exec-valor-carteira': 'cobranca-valor-carteira',
  'exec-titulos-vencidos': 'cobranca-titulos-vencidos',
  'exec-clientes-inad': 'cobranca-clientes-inad',
  'exec-aging-leve': 'cobranca-aging-1-2-dias',
};

export const DIRETORIA_INDICATOR_QUERY_IDS: Record<string, string> = {
  'custo-moto': 'erp-custo-por-moto',
  'motos-disponiveis': 'erp-motos-disponiveis',
  'motos-status': 'erp-motos-por-status',
  'faturamento-bruto': 'cobranca-faturamento-bruto',
  inadimplencia: 'cobranca-inadimplencia',
  infracoes: 'cobranca-infracoes',
  'motos-alugadas': 'erp-motos-alugadas',
  'rentabilidade-moto': 'erp-rentabilidade-moto',
  'locacao-local': 'erp-locacao-local',
};

export const DIRETORIA_OFICINA_QUERY_IDS = {
  porTecnico: 'oficina-tecnico-produtividade',
  locacaoEmpresa: 'oficina-locacao-empresa',
  agendamentos: 'oficina-agendamentos',
  osPeriodo: 'oficina-os-periodo',
} as const;

export function getIndicatorQueryId(indicatorId: string): string {
  return DIRETORIA_INDICATOR_QUERY_IDS[indicatorId] ?? '';
}
